

import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Loader from '../../../../Components/Loader';
import ModalDailog from '../../../../Components/Modal';
import DeleteIcon from '../../../../assets/images/delete-icon.svg';
import useUserData from '../../../../hooks/useUserData';
import { API_ENDPOINTS } from "../../../../utils/api";
import createAxiosInstance from "../../../../utils/axiosInstance";
import { formatDateTime, formatToUSD } from '../../../../utils/formatters';

const NeedsDetails = () => {
  const navigate = useNavigate();
  const axiosInstance = createAxiosInstance();
  const me = useUserData();
  const { needId } = useParams();
  const [need, setNeedDetails] = useState<any>([]);
  const [isCancelNeedModalOpen, setIsCancelNeedModalOpen] = useState(false);
  const [isFeesModalOpen, setIsFeesModalOpen] = useState(false);
  const [isLoding, setIsLoding] = useState(true);
  const location = useLocation();

  const handleCancelNeedModal = () => {
    setIsCancelNeedModalOpen(true);
  }

  const closeCancelNeedModal = () => {
    setIsCancelNeedModalOpen(false);
  }

  const handleFeesModal = () => {
    setIsFeesModalOpen(true);
  }

  const closeFeeModal = () => {
    setIsFeesModalOpen(false);
  }

  useEffect(() => {
    if (me) {
      getNeedDetails();
    }
  }, [me]);

  const getNeedDetails = async () => {
    try {
      const response = await axiosInstance.get(`${API_ENDPOINTS.SAFENIIGHT.GETRECENTNEEDS}/${needId}`);

      const data = response.data; // Extract the actual data

      setNeedDetails(data);
      setIsLoding(false);
    } catch (error) {
      setIsLoding(false);
      console.log(error);
    }
  };

  const handleCancel = async () => {
    try {
      setIsLoding(true);
      const payload: any = {
        status: "canceled"
      };

      await axiosInstance.put(`${API_ENDPOINTS.SAFENIIGHT.GETRECENTNEEDS}/${needId}`, payload);

      payload.reason = "inactivate";

      await axiosInstance.put(`${API_ENDPOINTS.SAFENIIGHT.UPDATEREQUEST}/${needId}`, payload);

      closeCancelNeedModal();

      getNeedDetails();
      setIsLoding(false);
    } catch (error) {
      setIsLoding(false);
      console.log(error);
    }
  };

  return (
    <>
      {isLoding && <Loader />}
      <div className="container py-4 md:py-10 2xl:py-[70px] flex justify-center">
        <div className="w-full xl:w-2/3">
          <div className="card mt-5 p-4 md:p-6">
            <h2 className='text-base lg:text-lg 2xl:text-2xl font-semibold'>Alert #{need?.sequenceId}</h2>
            <div className="border border-borderGray rounded-xl overflow-hidden mt-5">
              <table className="w-full text-xs 2xl:text-sm text-left rtl:text-right text-gray-500">
                <tbody>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Status
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      <div className="flex gap-3 items-center">
                        <span className={`badge ${need?.status === "open" ? 'badge-success' : 'badge-danger'}`}>
                          {need?.status === "new"
                            ? "Open" : need?.status === "canceled"
                              ? "Cancelled" : need?.status === "open" ? "Open" : need?.status === "closed" ? "Closed" : need?.status}
                        </span>
                        {need?.status === "open" && <span className='text-primary underline font-medium cursor-pointer text-sm' onClick={handleCancelNeedModal} >Cancel alert</span>}
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Requested Date
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {formatDateTime(need?.createdAt)}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Created by
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {me?.firstName} {me?.lastName}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Cost of Room
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {formatToUSD(need?.assessments?.[0]?.originalAmount)}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      <span className='text-primary cursor-pointer' onClick={handleFeesModal}>What is this?</span> Fees
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {formatToUSD(need?.assessments?.[0]?.fee)}
                    </td>
                  </tr>

                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Total Cost of Room
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {formatToUSD(need?.assessments?.[0]?.amount)}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Need reason
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {need?.assessments?.[0]?.needReason.length > 0
                        ? need?.assessments?.[0]?.needReason
                        : "-"
                      }
                      {need?.assessments?.[0]?.needReason === "Other" &&
                        need?.assessments?.[0]?.description && (
                          <span>: {need?.assessments?.[0]?.description}</span>
                        )}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Number of Bed Nights
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {need?.assessments?.[0]?.numberOfBednight}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Reference ID
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {need?.assessments?.[0]?.referenceId}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="flex gap-3">
              <div>
                <button type="button" className="btn btn-primary py-3 mt-4 btn-outline-gray transition-all delay-100 w-full" onClick={() => {
                    if (location.key !== "default") {
                      navigate(-1);
                    } else {
                    navigate("/safenight/needs", { replace: true });
                  }
                }}>
                  Go Back
                </button>
              </div>
              <Link to={'/safenight/needs/need-details/edit/' + needId}
                className="btn btn-primary py-3 mt-4"
              >
                Edit Alert
              </Link></div>
          </div>
        </div>
      </div>
      <ModalDailog isOpen={isCancelNeedModalOpen} onClose={closeCancelNeedModal} title="Cancel Alert" modalClassName="md:max-w-md lg:max-w-lg" isFooterAvailable={false}>
        <div className="flex flex-col text-center items-center">
          <p className='text-gray-700 font-semibold text-base lg:text-lg 2xl:text-xl mt-4 mb-3'>Are you sure?</p>
          <p className='text-gray-500 text-sm 2xl:text-base mb-4 font-medium'>Are you sure you want to cancel alert #{need?.sequenceId}? This process can not be undone</p>
          <div className="flex justify-center gap-3 items-center">
            <button className="btn btn-outline-gray py-2" type="submit">
              Cancel
            </button>
            <button className="btn bg-error text-white py-2" type="button" onClick={handleCancel}>
              Yes, I’m Sure
            </button>
          </div>
        </div>
      </ModalDailog>
      <ModalDailog isOpen={isFeesModalOpen} onClose={closeFeeModal} title="About fees" modalClassName="md:max-w-lg lg:max-w-lg" backButton="Close">
        <p className='text-sm 2xl:text-lg text-gray-600'>Payment processing fees are automatically calculated and added to the total amount requested to ensure that donations cover the full cost of the hotel room.</p>
        <p className='text-sm 2xl:text-lg text-gray-600 font-semibold mt-3'>Total Amount = Cost of Room + Fees</p>
      </ModalDailog>
    </>
  )
}

export default NeedsDetails